module.exports = __webpack_public_path__ + "img/avatar2.0f050f87.png";